<template>
<div>
  <slot />
  <el-dialog :title="$t('zhiji.knowlege.imExHistoryModal.title')" append-to-body class="import-model" :visible="showEdit" @close="showEdit=false">
    <Tabs
      :tabs-config="tabsConfig"
      @tabClick="tabClick"
    >
      <component :is="currentComponentName" :status="showEdit" />
    </Tabs>
  </el-dialog>
</div>
</template>

<script>
import Tabs from '@/views/zhiji/bComponents/switchs/Tabs.vue';
import ImportStatus from './ImportStatus.vue';
import ExportStatus from './ExportStatus.vue'
import SyncStatus from './SyncStatus.vue'
import i18n from "@/i18n";
import checkAuth from "@/lib/auth";

export default {
  name: 'StatusModel',
  components: {
    Tabs,
    ImportStatus,
    ExportStatus,
    SyncStatus,
  },
  data () {
    return {
      showEdit: false,
      currentComponentName: 'ImportStatus',
    };
  },
  computed:{
    isTestOrPreEnv() {
      const hostname = window.location.hostname;
      return hostname.includes('test');
    },
    tabsConfig(){
    const tabs = [{
        tabName: i18n.t("zhiji.knowlege.imExHistoryModal.importStatus"),
        contentName: 'ImportStatus',
      }];
    // 没有导出权限时不展示"导出状态"tab
    if (checkAuth("knowledge.fqamanager.export")) {
      tabs.push({
        tabName: i18n.t("zhiji.knowlege.imExHistoryModal.exportStatus"),
        contentName: 'ExportStatus',
      });
    }
    // 超管且正式环境才展示"同步状态"tab
    if (this.$store.state.auth.is_super === 1 && !this.isTestOrPreEnv) {
      tabs.push({
        tabName: i18n.t("zhiji.knowlege.imExHistoryModal.syncStatus"),
        contentName: 'SyncStatus',
      });
    }
    return tabs;
    },
  },
  mounted () {
    this.$slots.default[0].elm.addEventListener('click', this.openEdit);
  },
  beforeDestroy () {
    this.$slots.default[0].elm.removeEventListener('click', this.openEdit);
  },
  methods: {
    openEdit () {
      this.showEdit = true;
    },
    tabClick (data) {
      this.currentComponentName = data.componentName;
    },
  },
};
</script>

<style lang="less" scoped>
.import-model {
  /deep/.el-dialog {
    width: 65%;
    min-height: 65%;
    max-width: 1200px;
    .el-dialog__body {
      padding: 0;
      .tab-content {
        padding: 15px 12px 20px;
      }
    }
  }
}
</style>
